<template>
  <b-navbar toggleable="lg" type="dark" class="sticky-top" v-if="tokenLogin">
    <b-navbar-brand
      ><router-link to="prenota"> <img alt="Logo" src="../../assets/logo_pic.png" /></router-link
    ></b-navbar-brand>

    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav>
        <b-nav-item title="Prenota con nre o alpi" href="#" onclick="return false"
          ><router-link class="nav-link" to="prenota"><i class="fas fa-laptop-medical"></i> Prenotazione</router-link></b-nav-item
        >
        <b-nav-item title="Gestisci gli appuntamenti"
          ><router-link class="nav-link" to="listaappuntamenti"><i class="fas fa-clipboard-list"></i> Appuntamenti</router-link></b-nav-item
        >
        <b-nav-item href="/contatti" title="Aggiungi o modifica un contatto" v-if="contattiIsEnable"> <i class="fas fa-address-book"></i> Contatti </b-nav-item>
        <!-- <b-nav-item
            href="/listapendenzenre"
            title="Paga o consulta lo storico per te e i tuoi contatti"
          >
            <i class="fas fa-file-invoice-dollar"></i> Pagamenti
          </b-nav-item> -->
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
        <b-nav-item-dropdown right>
          <template #button-content> <i class="fas fa-file-invoice-dollar"></i> Pagamenti </template>
          <b-dropdown-item title="Paga o consulta lo storico per te e i tuoi contatti"
            ><router-link to="listapendenze"><i class="fas fa-file-invoice-dollar"></i> Pendenze da Pagare</router-link></b-dropdown-item
          >
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item href="#" onclick="return false"
            ><router-link to="storicopagamenti"><i class="fas fa-clock"></i> Storico Pagamenti</router-link></b-dropdown-item
          >
        </b-nav-item-dropdown>
      </b-navbar-nav>

      <!-- Right aligned nav items -->
      <b-navbar-nav class="ms-auto">
        <b-nav-item-dropdown class="nav-link" text="Profile" right>
          <!-- Using 'button-content' slot -->
          <template #button-content>
            <i class="fas fa-user"></i>
          </template>
          <b-dropdown-item
            ><router-link to="profilo"><i class="fas fa-user"></i> Account Personale</router-link></b-dropdown-item
          >
          <!-- <b-dropdown-item href="#"><i class="fas fa-lock"></i> Modifica Password</b-dropdown-item> -->
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item href="#" @click="onRichiestaDati"><i class="fas fa-database"></i> Richiesta Dati</b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item :href="linkTerminiServizio" target="_blank"><i class="fa fa-certificate"></i> Termini di Servizio</b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item
            ><router-link to="contattaci"><i class="fas fa-at"></i> Contatti</router-link></b-dropdown-item
          >
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item @click="redirectLogoutUri()"><i class="fas fa-power-off"></i> Log out</b-dropdown-item>

        </b-nav-item-dropdown>
        <b-nav-item
          ><router-link class="nav-link" to="faq"> Come fare per <i class="fas fa-question"></i></router-link
        ></b-nav-item>
      </b-navbar-nav> </b-collapse
    ><loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true" color="#274561" loader="dots" :height="120" :width="120"></loading>
  </b-navbar>
</template>
<script>
import Loading from "vue-loading-overlay";
import AuthService from "@/services/authService";
export default {
  components: { Loading },
  data() {
    return {
        linkTerminiServizio: "https://appsalute.regione.molise.it/ecupt/1.0.0/terminiServizio/display",
        pathResourceRichiesta: "/api/v2.0/appecupt/auth/scaricaAnagrafica",
        contattiIsEnable:false,
        tokenLogin: null,
        isLoading: false,
    };
  },
  mounted: function () {
    let me = this;
    me.tokenLogin = sessionStorage.getItem("loginData");
    me.contattiIsEnable = JSON.parse(sessionStorage.getItem("serviziAttivi")).contattiIsEnable;
    me.appuntamentiIsEnable = JSON.parse(sessionStorage.getItem("serviziAttivi")).appuntamentiIsEnable;
    me.prenotazioneIsEnable = JSON.parse(sessionStorage.getItem("serviziAttivi")).prenotazioneIsEnable;
  },
  methods: {
    async onLogOut() {
      // sessionStorage.clear();
      try {
        /*await this.$router.replace("/");
        await axios.get("https://idp.regione.molise.it/oidc/session/end?post_logout_redirect_uri=https://cup-portal.regione.molise.it");*/
      } catch (error) {
        console.log(error);
      }
    },
    async redirectLogoutUri() {
      if(sessionStorage.getItem('fseAccess') === 'true'){
        sessionStorage.clear();
        window.location.href = 'https://fsetest.regione.molise.it/fseui/cup'
      } else {
        sessionStorage.clear();
        window.location.href = 'https://idp.regione.molise.it/oidc/session/end?post_logout_redirect_uri=https://cup-portal.regione.molise.it'
      }
    },
    async onRichiestaDati() {
      let me = this;
      me.isLoading = true;
      try {
        const responseRichiestaDati = await AuthService.richiestaDatiAccount();
        if (responseRichiestaDati.data.stato === 200) {
          me.isLoading = false;
          me.$bvModal
            .msgBoxOk(responseRichiestaDati.data.data, {
              title: "Richiesta Dati",
              size: "md",
              okVariant: "btn-outline",
              headerClass: "vv-msg-header-success",
              footerClass: "p-2 border-top-0",
              centered: true,
            })
            .then(() => {
              me.$emit("saveEdit");
              me.isLoading = false;
            })
            .catch((err) => {
              me.isLoading = false;
              console.log(err);
            });
        } else {
          me.isLoading = false;
          this.$bvModal
            .msgBoxOk(responseRichiestaDati.data.errore, {
              title: "Errore",
              size: "md",
              okVariant: "outline-danger",
              headerClass: "vv-msg-header-danger",
              footerClass: "p-2 border-top-0",
              centered: true,
            })
            .then(() => {})
            .catch((err) => {
              me.isLoading = false;
              console.log(err);
            });
        }
      } catch (e) {
        console.log(e);
        me.isLoading = false;
      }
    },
  },
};
</script>
<style scoped>
a {
  color: #274561;
}
a:hover {
  color: #274561;
}
</style>
